import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { Modal, Button } from 'semantic-ui-react';

import {buttons, spacings} from 'style';

var style = {
    button: {
        ...buttons.base,
        marginLeft: 'auto',
        marginRight: 'auto',
        display: 'block',
    },
    description: {
        paddingBottom: spacings.base,
    }
}

const AlertModals = ({t, 
                      open,
                      size,
                      title, 
                      description, 
                      onClose, 
                      waitToShowNextMessage}) => (
    <div>
        {Boolean(open && !waitToShowNextMessage) &&
            <Modal closeIcon open onClose={onClose} size={size}>
                <Modal.Header>{title}</Modal.Header>
                <Modal.Content>
                    <div style={style.description}>
                        {description}
                    </div>
                    <Button type="button" 
                            style={style.button} 
                            onClick={onClose}>
                        {t('OK')}
                    </Button>
                </Modal.Content>
            </Modal>
        }
    </div>
);

export default translate('translation')(AlertModals);



// WEBPACK FOOTER //
// ./src/modules/alertmodal/AlertModals.js